import {Component, Input, ViewEncapsulation} from '@angular/core';
import {ReportTableRowParametersMetricStore} from './report-table-row-parameters-metric.store';
import {Observable} from 'rxjs';
import {MetricComponentObject} from '../../../../../../shared/classes/metric-component-object';
import {Serializer} from '../../../../../../shared/interfaces/serializer';
import {DataSetMetric} from '../../../../../../shared/interfaces/metrics';
import {map} from 'rxjs/operators';

@Component({
  selector: 'app-report-table-row-parameters-metric',
  templateUrl: './report-table-row-parameters-metric.component.html',
  styleUrls: ['./report-table-row-parameters-metric.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [ReportTableRowParametersMetricStore]
})
export class ReportTableRowParametersMetricComponent {
  @Input('parameter') public set parameter(metric: string | null | undefined) {
    if (metric) {
      this._reportTableRowParametersMetricStore.init(metric);
    }
  };

  public readonly metric$: Observable<Serializer<DataSetMetric> | undefined> = this._reportTableRowParametersMetricStore.metric$.pipe(
    map((metric: MetricComponentObject): Serializer<DataSetMetric> | undefined => metric?.payload as Serializer<DataSetMetric> | undefined)
  );

  constructor(
    private readonly _reportTableRowParametersMetricStore: ReportTableRowParametersMetricStore
  ) {
  }
}
